import { t } from 'ttag'
import { useState } from 'react'

import { Flex } from '@h2/components/layout/flex'
import {
    MuseoHeading,
    PillButton,
  } from '@h2/features/planning/earlyStyles'

import { GraduationYearFormModal } from './common/graduationYearFormModal'

const ChooseGrade = () => {
  const [isOpen, setIsOpen] = useState(false)


  return (
    <>
      <MuseoHeading level="1">{t`Let's get started!`}</MuseoHeading>
      <Flex justifyContent="space-between" wrap="wrap" direction="column">
        <PillButton
          onClick={() => setIsOpen(true)}
          fontSize="20px"
          weight="bold"
          isHoverStyled={false}>
          {t`Choose My Grade`}
        </PillButton>
      </Flex>
      <GraduationYearFormModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}

export { ChooseGrade }
